export default function LinkButton({ href, navigate, children, variant = "primary", className = "" }) {
  const variants = {
    primary: "bg-civic-blue text-white hover:bg-blue-800",
    secondary: "bg-white text-civic-navy ring-1 ring-civic-line hover:bg-slate-50",
    quiet: "text-civic-blue hover:text-blue-900"
  };

  return (
    <a
      href={href}
      onClick={(event) => {
        if (navigate && href.startsWith("/")) {
          event.preventDefault();
          navigate(href);
        }
      }}
      className={`focus-ring inline-flex min-h-11 items-center justify-center gap-2 rounded-md px-4 py-2 text-sm font-semibold transition ${variants[variant]} ${className}`}
    >
      {children}
    </a>
  );
}
